import React, { useEffect, useState } from "react";
import {
  FaUniversity,
  FaCaretUp,
  FaReceipt,
  FaMobileAlt,
} from "react-icons/fa";
import { BsCashStack } from "react-icons/bs";

const PaymentCard = ({
  iconType,
  mainTitle,
  subText,
  handleOnclick,
  valueToSet,
  closeThisOne,
  requiresPhoneNumber,
  setPaymentReferenceParent,
  setPaymentNarrationParent,
  setPhoneNumberParent,
  setPaymentDateParent,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [paymentReference, setPaymentReference] = useState("");
  const [paymentNarration, setPaymentNarration] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);
  const [paymentMethodSelected, setPaymentMethodSelected] = useState("");

  useEffect(() => {
    if (closeThisOne) {
      // console.log("closing this one");
      setPaymentReference(""); // reset payment reference
      setPaymentNarration(""); // reset payment narration
      setPhoneNumber(""); // reset phone number
      setIsExpanded(false);
    }
    // console.log("here is the value of closeThisOne", closeThisOne);
  }, [closeThisOne]);

  useEffect(() => {
    if (setPaymentReferenceParent) {
      setPaymentReferenceParent(paymentReference);
    }
    setPaymentNarrationParent(paymentNarration);
    if (setPhoneNumberParent) {
      setPhoneNumberParent(phoneNumber);
    }
    if (setPaymentDateParent) {
      setPaymentDateParent(paymentDate);
    }
  }, [paymentReference, paymentNarration, phoneNumber, paymentDate]);

  const handlePaymentMethodSelect = () => {
    setPaymentMethodSelected("BANK_TRANSFER");
    setIsExpanded(!isExpanded);
  };

  const handleDateChange = (date) => {
    setPaymentDate(date);
  };

  const paymentTypeSelect = {
    padding: "0px 15px",
    border: "1px solid #e0e0e0",
    // borderRadius: '8px',
    marginBottom: "0px",
    cursor: "pointer",
    transition: "all .75s ease",
    // backgroundColor: paymentMethodSelected === 'BANK_TRANSFER' ? '#f8f9fa' : 'white',
    // borderBottomLeftRadius: isExpanded ? '0' : '8px',
    // borderBottomRightRadius: isExpanded ? '0' : '8px',
    backgroundColor: "white",
    borderRadius: "10px",
    marginTop: "20px",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.28)",
    width: "90%",
    height:
      mainTitle === "Lipa na Mpesa"
        ? isExpanded
          ? "280px"
          : "50px"
        : isExpanded
        ? "362px"
        : "50px",
    paddingBottom: isExpanded ? "10px" : "0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: isExpanded ? "start" : "center",
    paddingTop: isExpanded ? "10px" : "0",
    cursor: "pointer",
  };

  const iconTwo = {
    marginRight: "15px",
    color: "rgb(25, 42, 58)",
    marginTop: "5px",
  };

  const paymentSelectTitleAndText = {
    fontSize: "20px",
    textAlign: "center",
  };

  const paymentSelectText = {
    fontSize: "14px",
    color: "#A8B4CC",
  };

  const caretStyle = {
    transition: "transform .75s ease",
    transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
    color: "#666",
    fontSize: "20px",
  };

  const expandedContentWrapper = {
    height: isExpanded ? "100px" : "0", // Adjust this value based on your content height
    overflow: "hidden",
    transition: "height .75s ease",
    width: "100%",
  };

  const expandedContent = {
    padding: isExpanded ? "15px" : "0 15px",
    borderRadius: "8px",
    backgroundColor: "#192a3a0f",
    transition: "padding .75s ease",
    marginTop: "10px",
    width: "100%",
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    outline: "none",
    border: "none",
  };
  const inputDate = {
    width: "100%",
    padding: "8px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    outline: "none",
    border: "none",
    fontFamily: "Karla, sans-serif",
    fontWeight: "200!important",
  };

  const handleInputFocus = (event) => {
    event.stopPropagation();
    // Delay to allow keyboard to appear
    setTimeout(() => {
      event.target.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 300);
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={paymentTypeSelect}
        onClick={() => {
          handlePaymentMethodSelect();
          handleOnclick(valueToSet);
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={iconTwo}>
            {iconType === "1" && (
              <>
                <FaReceipt fontSize={25} />
              </>
            )}
            {iconType === "2" && (
              <>
                <FaMobileAlt fontSize={25} />
              </>
            )}
            {iconType === "3" && (
              <>
                <FaUniversity fontSize={25} />
              </>
            )}
            {iconType === "4" && (
              <>
                <BsCashStack fontSize={25} />
              </>
            )}
          </div>
          <div style={paymentSelectTitleAndText}>
            <div>{mainTitle}</div>
            <div style={paymentSelectText}>{subText}</div>
          </div>
          <FaCaretUp style={caretStyle} />
        </div>
        {requiresPhoneNumber ? (
          <>
            <div style={expandedContentWrapper}>
              <div style={expandedContent}>
                <label htmlFor="phoneNumber">Phone Number</label>
                <input
                  onFocus={handleInputFocus}
                  type="number"
                  id="phoneNumber"
                  autoComplete="off"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  placeholder="Enter your phone number"
                  style={inputStyle}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            {" "}
            <div style={expandedContentWrapper}>
              <div style={expandedContent}>
                <label htmlFor="paymentReference">Payment Reference:</label>
                <input
                  onFocus={handleInputFocus}
                  type="text"
                  id="paymentReference"
                  value={paymentReference}
                  onChange={(e) => setPaymentReference(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  placeholder="Enter payment reference"
                  style={inputStyle}
                />
              </div>
            </div>
          </>
        )}

        <div style={expandedContentWrapper}>
          <div style={expandedContent}>
            <label htmlFor="paymentNarration">Payment Narration:</label>
            <input
              onFocus={handleInputFocus}
              type="text"
              id="paymentNarration"
              value={paymentNarration}
              autoComplete="off"
              onChange={(e) => setPaymentNarration(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              placeholder="Enter payment narration"
              style={inputStyle}
            />
          </div>
        </div>

        {mainTitle === "Lipa na Mpesa" ? (
          <></>
        ) : (
          <div style={expandedContentWrapper}>
            <div style={expandedContent}>
              <label htmlFor="paymentDate">Payment Date:</label>
              <input
                onFocus={handleInputFocus}
                type="date"
                id="paymentDate"
                autoComplete="off"
                onClick={(e) => e.stopPropagation()}
                placeholder="Enter payment date"
                style={inputDate}
                onChange={(e) => handleDateChange(e.target.value)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentCard;
